function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M16.19 2H7.81C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 14.35c-.41 0-.75-.34-.75-.75v-3.2c0-.41.34-.75.75-.75s.75.34.75.75v3.21c0 .41-.34.74-.75.74zm5 1.74c-.41 0-.75-.34-.75-.75V8.66c0-.41.34-.75.75-.75s.75.34.75.75v6.68c0 .41-.34.75-.75.75zm5-1.74c-.41 0-.75-.34-.75-.75v-3.2c0-.41.34-.75.75-.75s.75.34.75.75v3.21c0 .41-.34.74-.75.74z"
})));